<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="论文标题"
                  required
                  :rules="rules.required"
                  v-model="item.title"
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field
                  label="会议名称"
                  required
                  :rules="rules.required"
                  v-model="item.publication"
                />
              </v-flex>

              <v-flex xs12 sm5>
                <v-select
                  label="校内主管部门"
                  clearable
                  required
                  :rules="rules.required"
                  v-model="item.adminDeptId"
                  item-text="name"
                  item-value="dbid"
                  :items="adminDeptItems"
                />
              </v-flex>

              <v-flex xs12 sm7>
                <v-select
                  label="检索情况"
                  item-value="dbid"
                  item-text="name"
                  :items="indexItems"
                  v-model="item.indexIds"
                  :rules="rules.required"
                  multiple
                />
              </v-flex>

              <v-flex xs12 sm4>
                <v-menu
                  ref="menuPublDate"
                  :close-on-content-click="false"
                  v-model="menuPublDate"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="item.publDate"
                    label="发表时间"
                    :rules="rules.publDate"
                    hint="格式YYYY-MM, 如：2018-10"
                    persistent-hint
                  />
                  <v-date-picker
                    v-model="publDate"
                    type="month"
                    locale="zh-cn"
                    @change="nv => item.publDate = nv"
                  />
                </v-menu>
              </v-flex>

              <v-flex xs12 sm2>
                <v-text-field
                  label="卷"
                  required
                  v-model="item.volume"
                />
              </v-flex>

              <v-flex xs12 sm2>
                <v-text-field
                  label="期"
                  required
                  v-model="item.number"
                />
              </v-flex>

              <v-flex xs12 sm4>
                <v-text-field
                  label="页码"
                  required
                  v-model="item.pages"
                />
              </v-flex>

              <v-flex xs12>
                <x-authors
                  label="作者列表"
                  v-model="item.authors"
                  hint="填写作者列表"
                />

              </v-flex>

              <v-flex xs12 sm4>
                <v-select
                  :items="instRankItems"
                  v-model="item.institutionRank"
                  label="单位署名"
                  :rules="rules.institutionRank"
                  clearable
                />
              </v-flex>

              <v-flex xs12 sm8>
                <v-autocomplete
                  item-text="name"
                  item-value="dbid"
                  :items="deptItems"
                  v-model="item.deptId"
                  label="归属部门"
                  :rules="rules.required"
                  clearable
                />
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                  item-text="name"
                  item-value="dbid"
                  :items="subjectItems"
                  v-model="item.subjectId"
                  label="学科分类"
                  :rules="rules.required"
                  hint="所属一级学科分类"
                  persistent-hint
                  clearable
                />
              </v-flex>

              <v-flex xs12>
                <v-text-field label="备注" v-model="item.note"/>
              </v-flex>

              <v-flex xs12>
                <x-uploader
                  label="附件列表"
                  :action="fileUri"
                  v-model="item.attachments"
                  :size="Number(50)"
                  description="单个附件大小不超过 50M."
                />
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'
  import XAuthors from './widgets/Authors'
  import XJournal from './widgets/Journal'

  import XUploader from '@/components/global/Uploader'

  const baseUri = '/api/papr/paper';
  const deptUri = '/api/syst/department';
  const subjectUri = '/api/code/subject';

  const indexingURI = '/api/papr/indexing/';
  const levelURI = '/api/papr/level/';

  export default {
    mixins: [mixin.edit(baseUri)],
    components: {XAuthors, XJournal, XUploader},
    data() {
      return {
        formValid: false,

        fileUri: '/api/papr/file',

        item: {},
        freshItem: {
          "title": null,
          "journalId": null,
          "volume": null,
          "number": null,
          "publDate": null,
          "pages": null,
          "url": null,
          "deptId": null,
          "statusId": null,
          "subjectId": null,
          "category": 'C',
          "publication": null,
          "levelId": null,
          "institutionRank": null,
          "organizer": null,
          "address": null,
          "note": null,

          "authors": [],
          "indexings": []
        },

        journal: {
          journalId: null,
          publication: null,
          levelId: null,
          indexIds: [],

          levelName: null,
          indexNames: []
        },

        menuPublDate: false,
        publDate: null,

        deptItems: [],
        adminDeptItems: [],
        subjectItems: [],
        levelItems: [],
        indexItems: [],
        instRankItems: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(
          v => {
            return {
              value: v,
              text: v <= 0 ? '未署名' : `第${v}单位`
            }
          }
        ),

        rules: {
          required: [
            v => !!v || '必填项。',
            v => (v && v.length <= 255) || '长度必须小于255个字符。'
          ],
          institutionRank: [
            v => (v >= 0) || '必填项。',
          ],

          publDate: [
            v => !!v || "必填项。",
            v => window.xutil.regexpMonth().test(v) || '日期格式错误'
          ],
        }
      }
    },

    created() {
      this.axios.all([
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F'}}),
        this.axios.get(subjectUri, {params: {limit: 65535, disabled: 'F', codeIsNotNull: true, sort: 'order.asc'}}),
        this.axios.get(indexingURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
        this.axios.get(levelURI, {params: {limit: 65535, disabled: 'F', sort: 'order.asc'}}),
      ]).then(
        this.axios.spread(
          (rspDept, rspSubj, rspIdx, rspLvl) => {
            this.deptItems = rspDept.data.items;
            this.subjectItems = rspSubj.data.items;
            this.indexItems = rspIdx.data.items;
            this.levelItems = rspLvl.data.items;

            this.adminDeptItems = rspDept.data.items
              .filter(v => v.isAdmin && (!/公司$/ig.test(v.name)))
              .reverse();
          }
        )
      )
    },

    watch: {},
    methods: {
      // mixin 加载数据后调用
      afterGetData(data) {
        let jour = {};
        ['journalId', 'publication', 'levelId'].forEach(v => jour[v] = data[v]);
        jour.levelItems = data.level ? [data.level] : [];
        jour.indexItems = data.indexings || [];
        jour.indexIds = jour.indexItems.map(v => v.dbid);

        data.indexIds = jour.indexItems.map(v => v.dbid);

        this.journal = jour;

        data.publDate = data.publDate.substring(0, 7)
      },
    }
  }
</script>
